const simulator = {
  title1: 'احسبوا تمويلكم',
  title2: 'أنتم في حاجة لسلف، قوموا بحساب سلفكم عبر موقعنا.',
  recap: 'ملخص',
  monthlyPayment: 'الأداء الشهري',
  during: 'لمدة',
  month: 'شهرا',
  furtherInfo:
    '.تودون الحصول على معلومات تكميلية، زودونا برقم هاتفكم ونلتزم بإجابتكم في أقرب الآجال',
  requestLoan: 'اطلبوا هذا السلف',
  requestLoanHeaderTitle: 'اطلبوا سلفا',
  requestLoanTitle: 'لطلب سلف',
  simulation:
    '.تعرض نتيجة هذا الحساب من باب الإشارة. وهي لا تشكل بأي حال من الأحوال التزاما تعاقديا من لدن البنك الشعبي *',
  investmentTabTitle: 'قرض',
  amount: 'المبلغ',
  rate: 'سعر الفائدة',
  duration: 'المدة',
  delay: 'مؤجل',
  creditSimulator: 'حاسبة القروض',
  copyright: 'COPYRIGHT 2020 - GROUPE BANQUE POPULAIRE - TOUS DROITS RÉSERVÉS',
  goback: 'رجوع',
  dh: 'درهم',
  horsTaxes: '(دون احتساب الرسوم)',
};

export default simulator;
